module.exports = __webpack_public_path__ + "static/img/code-wechat.005aa5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/code-wechat.jpg
// module id = mXUA
// module chunks = 1